<loading-contents *ngIf="photography == null"></loading-contents>
<div class="main-contents" *ngIf="photography != null">
    <div class="webslider">    
        <owl-carousel-o [options]="customOptions">
            <ng-template carouselSlide>
                <div class="slide">
                    <img src="../../assets/images/photography/photography-1.jpg">
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="slide">
                    <img src="../../assets/images/photography/photography-2.jpg">
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="slide">
                    <img src="../../assets/images/photography/photography-3.jpg">
                </div>
            </ng-template>   
            <ng-template carouselSlide>
                <div class="slide">
                    <img src="../../assets/images/photography/photography-4.jpg">
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="slide">
                    <img src="../../assets/images/photography/photography-5.jpg">
                </div>
            </ng-template>   
        </owl-carousel-o>
    </div>
    <div class="contents">
    <div class="container">
        <h1 class="page-title icon-screen">Photography</h1>
        <p>While I love web development and design, my real passion lies in photography. Since buying my very first camera in 2003, I have dedicated my heart, effort and talents into continuously improving my skill in capturing the beauty of nature, people, animals and architecture. With a keen eye for lighting, angle and framing, Bill truly understands how a properly taken photograph can capture the pure essence of a person, landscape or object. Making my passion available to others, Bill is available for portrait, landscape and event photography work.</p>
        <div class="row">
        
        </div>
    </div>
    </div>
    <div class="items-wrapper padding-top-30">
        <div class="container">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
                <a class="nav-link active" id="home-tab" data-toggle="tab" href="#all" role="tab" aria-controls="All"
                aria-selected="true">All<span class="total">( {{total}} )</span></a>
            </li>
            <li class="nav-item">
                <a class="nav-link" id="Portrait-tab" data-toggle="tab" href="#Portrait" role="tab" aria-controls="Portrait"
                aria-selected="false">Portrait<span class="total">( {{objectKeys(portrait).length}} )</span></a>
            </li>
            <li class="nav-item">
                <a class="nav-link" id="Landscape-tab" data-toggle="tab" href="#Landscape" role="tab" aria-controls="Landscape"
                aria-selected="false">Landscape<span class="total">( {{objectKeys(landscape).length}} )</span></a>
            </li>
            <li class="nav-item">
                <a class="nav-link" id="Wedding-tab" data-toggle="tab" href="#Wedding" role="tab" aria-controls="Wedding"
                aria-selected="false">Wedding<span class="total">( {{objectKeys(wedding).length}} )</span></a>
            </li>
            <li class="nav-item">
                <a class="nav-link" id="Events-tab" data-toggle="tab" href="#Events" role="tab" aria-controls="Events"
                aria-selected="false">Events<span class="total">( {{objectKeys(events).length}} )</span></a>
            </li>
            <li class="nav-item">
                <a class="nav-link" id="Others-tab" data-toggle="tab" href="#Others" role="tab" aria-controls="Others"
                aria-selected="false">Others<span class="total">( {{objectKeys(others).length}} )</span></a>
            </li>
            </ul>
            
            <div class="tab-content">
            <div class="tab-pane active" id="all" role="tabpanel" aria-labelledby="home-tab">
                <div class="row" *ngIf="photography">
                    <div class="col-lg-2 col-xs-6 col-md-2 col-sm-6" (click)="onSelect(item)"  *ngFor="let item of photography">
                        <div class="card">
                            <div class="card-image">
                                <img src="../../assets/images/photography/thumbnail/{{item.thumbnail_image}}" class="card-img-top" alt="{{item.title}}">
                            </div>                            
                            <div class="card-body">
                                <div class="body-wrapper">                                
                                <div class="siteTitle">
                                    <h6>{{item.title}}</h6>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane" id="Portrait" role="tabpanel" aria-labelledby="Portrait-tab">
                <div class="row" *ngIf="portrait">
                    <div class="col-lg-2 col-xs-6 col-md-2 col-sm-6" (click)="onSelect(item)" *ngFor="let item of portrait">
                        <div class="card">
                        <div class="card-image">
                            <img src="../../assets/images/photography/thumbnail/{{item.thumbnail_image}}" class="card-img-top" alt="{{item.title}}">
                        </div>                            
                        <div class="card-body">
                            <div class="body-wrapper">                                
                            <div class="siteTitle">
                                <h6>{{item.title}}</h6>
                                <!-- <span>{{item.item_category}} Photography</span> -->
                            </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane" id="Landscape" role="tabpanel" aria-labelledby="Landscape-tab">
                <div class="row" *ngIf="landscape">
                    <div class="col-lg-2 col-xs-6 col-md-2 col-sm-6" (click)="onSelect(item)" *ngFor="let item of landscape">
                        <div class="card">
                        <div class="card-image">
                            <img src="../../assets/images/photography/thumbnail/{{item.thumbnail_image}}" class="card-img-top" alt="{{item.title}}">
                        </div>                            
                        <div class="card-body">
                            <div class="body-wrapper">                                
                            <div class="siteTitle">
                                <h6>{{item.title}}</h6>
                                <!-- <span>{{item.item_category}} Photography</span> -->
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane" id="Wedding" role="tabpanel" aria-labelledby="Wedding-tab">
                <div class="row" *ngIf="wedding">
                    <div class="col-lg-2 col-xs-6 col-md-2 col-sm-6" (click)="onSelect(item)" *ngFor="let item of wedding">
                        <div class="card">
                        <div class="card-image">
                            <img src="../../assets/images/photography/thumbnail/{{item.thumbnail_image}}" class="card-img-top" alt="{{item.title}}">
                        </div>                            
                        <div class="card-body">
                            <div class="body-wrapper">                                
                            <div class="siteTitle">
                                <h6>{{item.title}}</h6>
                                <!-- <span>{{item.item_category}} Photography</span> -->
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane" id="Events" role="tabpanel" aria-labelledby="Events-tab">
                <div class="row" *ngIf="events">
                    <div class="col-lg-2 col-xs-6 col-md-2 col-sm-6" (click)="onSelect(item)" *ngFor="let item of events">
                        <div class="card">
                        <div class="card-image">
                            <img src="../../assets/images/photography/thumbnail/{{item.thumbnail_image}}" class="card-img-top" alt="{{item.title}}">
                        </div>                            
                        <div class="card-body">
                            <div class="body-wrapper">                                
                            <div class="siteTitle">
                                <h6>{{item.title}}</h6>
                                <!-- <span>{{item.item_category}} Photography</span> -->
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane" id="Others" role="tabpanel" aria-labelledby="Others-tab">
                <div class="row" *ngIf="others">
                    <div class="col-lg-2 col-xs-6 col-md-2 col-sm-6" (click)="onSelect(item)" *ngFor="let item of others">
                        <div class="card">
                        <div class="card-image">
                            <img src="../../assets/images/photography/thumbnail/{{item.thumbnail_image}}" class="card-img-top" alt="{{item.title}}">
                        </div>                            
                        <div class="card-body">
                            <div class="body-wrapper">                                
                            <div class="siteTitle">
                                <h6>{{item.title}}</h6>
                                <!-- <span>{{item.item_category}} Photography</span> -->
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>